import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { SectionHeading } from "@/components/site/SectionHeading";
import { webPageScript } from "@/lib/webpage-jsonld";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Us | Online Tax VAT Bangladesh" },
      { name: "description", content: "Learn about Online Tax VAT Bangladesh — trusted tax, VAT, e-TIN and income tax return consultancy for individuals and businesses across Bangladesh." },
      { property: "og:title", content: "About Us — Online Tax VAT Bangladesh" },
      { property: "og:description", content: "Trusted partner for tax, VAT, e-TIN and income tax return services in Bangladesh." },
      { property: "og:url", content: "https://onlinetaxvat.com/about" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://onlinetaxvat.com/about" }],
    scripts: [webPageScript({
      path: "/about",
      name: "About Us — Online Tax VAT Bangladesh",
      description: "Trusted partner for tax, VAT, e-TIN and income tax return services in Bangladesh.",
    })],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <SiteShell>
      <section className="container-page py-12">
        <SectionHeading eyebrow="Company" title="About Us – Online Tax VAT Bangladesh" description="Your trusted partner for tax, VAT and compliance in Bangladesh." />
        <article className="prose prose-slate dark:prose-invert mt-8 max-w-3xl">
          <p>
            Welcome to <strong>Online Tax VAT Bangladesh</strong>, your trusted and reliable partner for all kinds of tax, VAT, e-TIN, and income tax return submission services in Bangladesh. We are a team of professional tax consultants and legal experts dedicated to simplifying complex financial and taxation processes for individuals, small businesses, and corporate organizations.
          </p>
          <h2>Our Mission</h2>
          <p>
            To provide seamless, accurate, and fast tax and VAT consultancy services, ensuring complete compliance with the laws of the National Board of Revenue (NBR), Bangladesh.
          </p>
          <h2>Why Choose Us?</h2>
          <ul>
            <li>Expert guidance on e-TIN registration and annual income tax return filing.</li>
            <li>Professional handling of VAT registration, returns, and compliance.</li>
            <li>100% data confidentiality and secure processing.</li>
            <li>Dedicated customer support to solve your tax-related queries instantly.</li>
          </ul>
          <p>
            Whether you are a salaried employee, a business owner, or a freelancer, we make your tax journey hassle-free.
          </p>
          <h2>Related</h2>
          <ul>
            <li><Link to="/services">All VAT &amp; Tax services</Link></li>
            <li><Link to="/packages">Service packages</Link></li>
            <li><Link to="/why-choose-us">Why choose us</Link></li>
            <li><Link to="/contact">Contact our team</Link></li>
          </ul>
        </article>
      </section>
    </SiteShell>
  );
}
